<app-empty-state
    i18n-title
    title="Tell us about you"
    type="noData"
>
    <span i18n
        >This questionnaire will help the MDR analysts learn more about your environment in an effort to better protect you. Providing
        detailed answers to these questions will aid the intelligence analysts to build a threat model, as well as identify key areas of
        interest to monitor through research and dashboards for relevant threat intelligence</span
    >
    <br />
    <button
        (click)="startQuestionnaire()"
        [routerLink]="'/cq/questionnaire'"
        class="m-t-24"
        color="primary"
        i18n
        id="start-questionnaire-button"
        mat-flat-button
    >
        Start
    </button>
</app-empty-state>
